/**
 * @module themeCountdown
 */

module.exports = function() {
    const countdownBlock = document.getElementById( 'theme-countdown' );
    countdownBlock.classList.remove( 'd-none' );
    const countdownTime = document.getElementById( 'countdown-time' ).getAttribute( 'datetime' );
    const deadline = new Date( countdownTime );

    let timerId = null;

    function finalTimer() {
        document.getElementById( 'countdown-time' ).classList.add( 'd-none' );
        document.getElementById( 'countdown-final' ).classList.remove( 'd-none' );
    }
    function countdownTimer() {
        const different = deadline - new Date();
        if ( different <= 0 ) {
            finalTimer();
            clearInterval( timerId );
        } else {
            const days = Math.floor( different / 1000 / 60 / 60 / 24 );
            const hours = Math.floor( different / 1000 / 60 / 60 ) % 24;
            const minutes = Math.floor( different / 1000 / 60 ) % 60;
            const seconds = Math.floor( different / 1000 ) % 60;

            document.getElementById( 'countdown-dd' ).innerHTML = days > 0 ? days + ' days,' : document.getElementById( 'countdown-dd' ).classList.add( 'd-none' );
            document.getElementById( 'countdown-hh' ).innerHTML = hours === 0 && days === 0 ? document.getElementById( 'countdown-hh' ).classList.add( 'd-none' ) : hours + ' hours,';
            document.getElementById( 'countdown-mm' ).innerHTML = minutes === 0 && hours === 0 && days === 0 ? document.getElementById( 'countdown-mm' ).classList.add( 'd-none' ) : minutes + ' minutes,';
            document.getElementById( 'countdown-ss' ).innerHTML = seconds + ' seconds.';
        }
    }

    document.getElementById( 'countdown-hide' ).addEventListener( 'click', () => {
        countdownBlock.classList.add( 'd-none' );
    } );

    if ( ! Number.isFinite( ( Date.parse( deadline ) / 1000 ) ) ) {
        finalTimer();
        document.getElementById( 'countdown-final' ).innerHTML = 'The date entered is incorrect!';
    }

    countdownTimer();
    timerId = setInterval( countdownTimer, 1000 );
}; // exports
